export default __webpack_public_path__ + "locales/ar-SA/InfoPanel.json?hash=d0c61d805d824530d2dcd1851ba54712";